<template>
  <canvas
    :id="'barcode_'+id"
    width="width"
    height="height"
  />
</template>

<script>

import { barcode } from '@core/utils/utils'

export default {
  props: {
    id: {
      type: String,
      default: () => '',
    },
    width: {
      type: String,
      default: () => '120px',
    },
    height: {
      type: String,
      default: () => '80px',
    },
  },
  mounted() {
    this.codeGenerator(this.id)
  },
  methods: {
    async codeGenerator(waybill) {
      barcode(`barcode_${waybill}`, waybill)
    },
  },
}
</script>
